import { ReloadOutlined } from '@ant-design/icons';
import { Button, Result } from 'antd';
import { isRouteErrorResponse, useRouteError } from 'react-router-dom';

function getErrorDescription(error: unknown) {
  if (isRouteErrorResponse(error)) {
    return error.status === 404
      ? '此頁面可能已移動，或你目前的操作情境無權存取。'
      : `系統回傳 ${error.status}，請重新載入後再試。`;
  }

  if (error instanceof Error && /module script|dynamic import|failed to fetch/i.test(error.message)) {
    return '系統剛完成更新，瀏覽器仍保留舊版頁面資源。請重新載入以使用最新版本。';
  }

  return '頁面載入時發生錯誤。請重新載入；若問題持續發生，請聯絡系統管理員。';
}

export default function RouteErrorPage() {
  const error = useRouteError();

  return (
    <main className="bootstrap-error">
      <Result
        status="error"
        title="無法載入頁面"
        subTitle={getErrorDescription(error)}
        extra={(
          <Button type="primary" icon={<ReloadOutlined />} onClick={() => window.location.reload()}>
            重新載入
          </Button>
        )}
      />
    </main>
  );
}
